export default "__VITE_ASSET__9b937376__"